import { inject, Service } from "@angular/core";

import { MainResponseModel } from "../models";
import { ContextualHelp, Faq, FaqCategory, FaqQuestionType, HelpFormPath } from "../models/online-help-model";
import { MainService } from "./main-service";

@Service()
export class OnlineHelpService {
  private readonly _mainService = inject(MainService);

  public getAllFAQCategories() {
    return this._mainService.sendRequest<MainResponseModel<FaqCategory[]>>({
      method: "POST",
      url: `faqs/categoryGetall`,
      data: {},
    });
  }

  public createFAQCategory(data: FaqCategory) {
    return this._mainService.sendRequest<MainResponseModel<number>>({
      method: "POST",
      url: `faqs/categoryCreate?isFinish=false`,
      data,
    });
  }

  public createFAQ(data: Faq) {
    return this._mainService.sendRequest<MainResponseModel<number>>({
      method: "POST",
      url: `faqs/create?isFinish=false`,
      data,
    });
  }

  public updateFAQ(data: Faq) {
    return this._mainService.sendRequest<MainResponseModel<number>>({
      method: "POST",
      url: `faqs/update?isFinish=false`,
      data,
    });
  }

  public deleteFAQ(id: number) {
    return this._mainService.sendRequest<MainResponseModel<number>>({
      method: "DELETE",
      url: `faqs/delete/${id}`,
    });
  }

  public getFAQ(id: number) {
    return this._mainService.sendRequest<MainResponseModel<Faq>>({
      method: "GET",
      url: `faqs/getById/${id}`,
    });
  }

  public updateFAQCategory(data: FaqCategory) {
    return this._mainService.sendRequest<MainResponseModel<number>>({
      method: "POST",
      url: `faqs/categoryUpdate?isFinish=false`,
      data,
    });
  }

  public deleteFAQCategory(id: number) {
    return this._mainService.sendRequest<MainResponseModel<number>>({
      method: "DELETE",
      url: `faqs/categoryDelete/${id}`,
    });
  }

  public getFAQSearchCategories() {
    return this._mainService.sendRequest<MainResponseModel<FaqCategory[]>>({
      method: "POST",
      url: `faqs/categoryGetall`,
      data: {},
    });
  }

  public getFAQCategoryQuestions(offset: number = 0, catId?: number, searchFields?: { searchFields: FaqQuestionType }) {
    let url = `faqs/getall?limit=10&offset=${offset}`;
    if (catId) url += `&catId=${catId}`;

    return this._mainService.sendRequest<MainResponseModel<Faq[]>>({
      method: "POST",
      url: url,
      data: searchFields ?? {},
    });
  }

  public geContentByPath(path: string) {
    return this._mainService.sendRequest<MainResponseModel<ContextualHelp>>({
      method: "GET",
      url: `help/contentGetByPath?path=${path}`,
      loader: false,
    });
  }

  public getContextualHelpContent(id: number) {
    return this._mainService.sendRequest<MainResponseModel<ContextualHelp>>({
      method: "GET",
      url: `help/contentGetById/${id}`,
    });
  }

  public contentUpdate(data: ContextualHelp) {
    return this._mainService.sendRequest<MainResponseModel<null>>({
      method: "POST",
      url: `help/contentUpdate`,
      data,
    });
  }

  public deleteContent(id: number) {
    return this._mainService.sendRequest<MainResponseModel<number>>({
      method: "DELETE",
      url: `help/contentDeleteById/${id}`,
    });
  }

  public getAllUnpublished() {
    return this._mainService.sendRequest<MainResponseModel<HelpFormPath[]>>({
      method: "GET",
      url: `help/getAllUnpublished`,
    });
  }
}
